import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { ReportsPage } from "./ReportsPage";
import { DashboardShell } from "@/components/dashboard/DashboardShell";

export const ReportsPageContainer: React.FC = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) {
      navigate("/auth/signin");
    }
  }, [user, loading, navigate]);

  if (loading) {
    return (
      <DashboardShell>
        <div className="flex h-[50vh] items-center justify-center">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
        </div>
      </DashboardShell>
    );
  }

  if (!user) {
    return null;
  }

  return <ReportsPage />;
};

export default ReportsPageContainer;
